import React from 'react';
import ProductPicker from '../components/ProductPicker';
// import SimpleCard from '../teal-react/components/organisms/SimpleCard';
// import QcPicker from '../components/QcPicker';
import QcViewer from '../components/QcViewer';
// import FormulasList from '../components/FormulasList';
// import TestingSetupManager from '../components/TestingSetupManager';
import { useParams } from 'react-router';
// import { Close } from '@mui/icons-material';
import ProductViewer from '../components/ProductViewer';
import ProductForm from '../components/ProductForm';
import Authenticated from '../components/Auth/Authenticated';
// import { useNavigate } from 'react-router';

const Products = () => {
  const [editProduct, setEditProduct] = React.useState<any>(null);
  const { product_id, qc_id } = useParams();
  const [selectedProduct, setSelectedProduct] = React.useState<number>(
    Number(product_id)
  );
  const [selectedQc, setSelectedQc] = React.useState<any>(qc_id);

  return (
    <div className="row">
      <div className="cols noprint" style={{ width: 320 }}>
        <ProductPicker
          selected={selectedProduct}
          onAddClick={() => setEditProduct({})}
          onSelect={(product: any) => {
            setSelectedProduct(product.id);
            setSelectedQc(null);
            setEditProduct(null);
          }}
          // preSelectId={product_id}
          // onPreselectLoaded={(prod: any) => {
          //   setSelectedProduct(prod);
          // }}
        />
      </div>
      {editProduct ? (
        <div className="xcol" style={{ paddingLeft: 8, width: 700 }}>
          <ProductForm
            model={editProduct}
            onClose={() => setEditProduct(null)}
            onCreate={(id: number) => {
              setSelectedProduct(id);
            }}
          />
        </div>
      ) : (
        <div className="col" style={{ paddingLeft: 8 }}>
          {selectedQc ? (
            <Authenticated>
              <QcViewer id={selectedQc} onClose={() => setSelectedQc(null)} />
            </Authenticated>
          ) : null}

          {selectedProduct && !selectedQc ? (
            <Authenticated>
              <ProductViewer
                product_id={selectedProduct}
                onQcSelect={setSelectedQc}
                onEdit={setEditProduct}
              />
            </Authenticated>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Products;
